// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const pricingPlansClient = createTypedClient();
export const createPricingPlansClient = (config) => createTypedClient(config);
